import React, { createContext, useContext, useState } from "react";
import PropTypes from "prop-types";
import WorkItemEditModel from "../models/WorkItemEditModel";
import useLogger from "../util/Logger";
import UpdateWorkItemModel from "./webServiceModels/UpdateWorkItemModel";
import getCreateWorkItemModelByTemplate from "../util/getCreateWorkItemModelByTemplate";
import { useAuth } from "./AuthHook";

const WorkItemsContext = createContext();

export default function WorkItemsProvider({ children }) {
  const [workItemEntry, setWorkItemEntry] = useState({});
  const logger = useLogger();
  const auth = useAuth();

  const clearEntry = (
    preferredAppointmentDate,
    preferredAppointmentSlot,
    preferredAppointmentSlotTitle,
    appointmentConfirmed,
    appointmentConfirmedTitle,
    workitemcategoryid,
    workitemcategoryname,
    workitemtemplateid,
    workitemtemplateref,
    jobSpecificAccessNotes,
    projectId,
    projectName,
    redFlag,
    propertyAccessNotes,
    workItemNotes,
    expectedParts,
    faultyAssets
  ) => {
    setWorkItemEntry(
      new WorkItemEditModel(
        preferredAppointmentDate,
        preferredAppointmentSlot,
        preferredAppointmentSlotTitle,
        appointmentConfirmed,
        appointmentConfirmedTitle,
        workitemcategoryid,
        workitemcategoryname,
        workitemtemplateid,
        workitemtemplateref,
        jobSpecificAccessNotes,
        projectId,
        projectName,
        redFlag,
        propertyAccessNotes,
        workItemNotes,
        expectedParts,
        faultyAssets
      )
    );
  };

  const getEntry = () => workItemEntry;

  const setEntry = (workOrderItem) => {
    // eslint-disable-next-line no-console
    console.log("workOrderItem", workOrderItem);
    setWorkItemEntry({
      ...workOrderItem,
      createdBy: `${auth.user.idToken.payload.given_name} ${auth.user.idToken.payload.family_name}`,
    });
  };

  // workItem as defined in WorkItemEditModel
  const updateWorkItem = async (workItem) => {
    logger.debug("WorkItemsProvider.updateWorkItem", `PATCH field/workItem`);
    const webServiceWorkOrder = UpdateWorkItemModel(workItem);
    await auth.patch(`field/workItem`, webServiceWorkOrder);
  };

  // WorkItem is of type WorkItemModel
  const cancelWorkItem = async (
    workItemId,
    workitemtemplateid,
    cancelReason,
    cancelledBy,
    subCategory
  ) => {
    const update = {
      workitemid: workItemId,
      workitemtemplateid,
      ...(cancelReason ? { cancelReason } : {}),
      ...(cancelledBy ? { cancelledBy } : {}),
      ...(subCategory ? { subCategory } : {}),
    };

    logger.debug(
      "WorkItemsProvider.cancelWorkItem",
      `PATCH field/workItem/cancel`
    );
    await auth.patch(`field/workItem/cancel`, update);
  };

  // WorkItem is of type WorkItemModel
  const closeWorkItem = async (workItemId, workitemtemplateid) => {
    const update = {
      workitemid: workItemId,
      workitemtemplateid,
    };

    logger.debug(
      "WorkItemsProvider.closeWorkItem",
      `PATCH field/workItem/close`
    );
    await auth.patch(`field/workItem/close`, update);
  };

  // workOrder: WorkOrderEntryModel, workItem: WorkItemEditModel
  const createNewWorkOrderItem = async (workOrder, workItem) => {
    // eslint-disable-next-line no-console
    console.log("CREATING NEW WORK ORDER ITEM");
    // eslint-disable-next-line no-console
    console.log("workOrder", workOrder);
    // eslint-disable-next-line no-console
    console.log("workItem", workItem);
    // This route is creating Work Item on an EXISTING Work Order
    logger.debug(
      "WorkOrdersProvider.createNewWorkOrderItem",
      `PUT field/workItem`
    );
    const createWorkItemModel = getCreateWorkItemModelByTemplate(
      workItem.workitemtemplateref
    );
    // eslint-disable-next-line no-console
    console.log(workOrder);
    // eslint-disable-next-line no-console
    console.log(workItem);
    const webServiceWorkOrderItem = createWorkItemModel({
      ...workOrder,
      ...workItem,
      id: workOrder.id,
    });
    await auth.put(`field/workItem`, webServiceWorkOrderItem);
  };

  return (
    <WorkItemsContext.Provider
      value={{
        clearEntry,
        getEntry,
        setEntry,
        updateWorkItem,
        createNewWorkOrderItem,
        cancelWorkItem,
        closeWorkItem,
      }}
    >
      {children}
    </WorkItemsContext.Provider>
  );
}

WorkItemsProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useWorkOrderItems = () => useContext(WorkItemsContext);
